module.exports = __webpack_public_path__ + "static/img/collect.1c0785a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collect.png
// module id = +/eM
// module chunks = 36